import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()


export const actions = {
  submit: action({
    type: 'services.submit',
    action: (params, http) => {
      return http.post(`/backstreet/api/shangce/activity/submit`, params )
    },
    handler: (state, result) => {
      return {
        ...state
      }
    }
  }, reducerHandler)
}



// WEBPACK FOOTER //
// ./modules/services/redux.js